<template>
    <footer class="footer container">
        <div class="footer__copyright">
            Сделано на <a target="_blank" href="https://fitbase.io/?utm_source=widget&utm_campaign=account">fitbase.io</a>
        </div>

        <div class="flex-container rules">
          <div class="rules-flex-container">
              <div v-if="documentsModules?.payment_rules?.enable">
                <a :href="documentsModules.payment_rules.link">
                  Правила оплаты
                </a>
              </div>
              <div v-if="documentsModules?.club_rules?.enable">
                <a :href="documentsModules.club_rules.link">
                  Правила клуба
                </a>
              </div>
          </div>
          <div class="rules-flex-container" style="margin-left: auto">
            <img src="../../../assets/img/mir.png" alt="" style="margin-right: 20px">
            <img src="../../../assets/img/mir-accept.png" alt="">
          </div>
        </div>

        <div class="flex-container legal-entity">
            <div>
                <p v-if="documentsLk?.email">
                  <a :href="'mailto:' + documentsLk.email">
                    {{ documentsLk.email }}
                  </a>
                </p>
                <p v-if="documentsLk?.legal_entity?.name">
                  <span>
                    {{ documentsLk.legal_entity.name }}
                  </span>
                  <span v-if="documentsLk?.legal_entity?.inn">
                    , ИНН {{ documentsLk.legal_entity.inn }}
                  </span>
                </p>
                <p v-if="documentsLk?.legal_entity?.address">
                  {{ documentsLk.legal_entity.address }}
                </p>
            </div>
            <div class="offer-container">
                <div v-if="documentsModules?.offer?.link">
                  <a :href="documentsModules.offer.link">
                    Публичная оферта
                  </a>
                </div>
                <div v-if="documentsModules?.processing_personal_data?.link">
                  <a :href="documentsModules.processing_personal_data.link">
                    Политика конфиденциальности
                  </a>
                </div>
            </div>
        </div>
    </footer>

    <success-modal />
    <item-modal-cancel-subscription v-if="cancelItemSubscription" :item="cancelItemSubscription"/>
    <shop-modal-item/>
    <shop-modal-payment v-if="paymentItem"/>
    <shop-modal-success v-if="successPayment && !hasScheduleId"/>
    <modal-preloader v-if="preloaderModal"/>
    <shop-modal-reservation v-if="reservationModal" :schedule-id="reservationScheduleId"/>
</template>

<script>
  import ShopModalItem from "../../../components/shop/ShopModalItem";
  import ShopModalPayment from "../../../components/shop/ShopModalPayment";
  import ModalPreloader from "../../../components/ModalPreloader";
  import ShopModalSuccess from "../../../components/shop/ShopModalSuccess";
  import ItemModalCancelSubscription from "../../../components/ItemModalCancelSubscription.vue";
  import SuccessModal from "@/components/SuccessModal.vue";
  import ShopModalReservation from "@/components/shop/ShopModalReservation.vue";
  export default {
    name: 'FooterLayout',
      components: {
        ShopModalReservation,
        SuccessModal, ItemModalCancelSubscription, ShopModalSuccess, ModalPreloader, ShopModalPayment, ShopModalItem},
      computed: {
          preloaderModal: function() {
              return this.$store.getters.showModalPreloader;
          },
          paymentItem: function() {
              return this.$store.getters.shopPaymentModal;
          },
          successPayment: function() {
              return this.$store.getters.shopSuccessModal;
          },
          cancelItemSubscription: function(){
              return this.$store.getters.itemCancelSubscriptionModal;
          },
          reservationModal() {
              return this.$store.getters.shopReservationModal;
          },
          reservationScheduleId() {
              return this.$store.getters.shopReservationScheduleId;
          },
          hasScheduleId() {
            return Boolean(this.$route.query.schedule_id);
          },
          documentsLk: function () {
            return this.$store.getters.documentsLk
          },
          documentsModules: function () {
            return this.$store.getters.documentsModules
          }
      }
  }
</script>
